/**
 * Step 9: Detalhes das Restrições
 * Coleta informações sobre o tipo de restrição
 */

import React, { useState } from 'react';
import { StepContainer, FormFieldGroup, StepNavigation } from '../components';
import { StepProps, useFormContext } from '../context';
import { useFormValidation } from '../hooks';
import { capitalizeEachWord, validateText } from '../validators';

const Step2_Nome: React.FC<StepProps> = ({ onNext, onPrevious, data, isLoading }) => {
  const { updateFields } = useFormContext();
  const [localData, setLocalData] = useState({ restrictionDetails: data.restrictionDetails || '' });
  const [errors, setErrors] = useState<Record<string, string>>({});

  const handleChange = (value: string) => {
    setLocalData({ restrictionDetails: value });
    setErrors({});
  };

  const handleNext = () => {
    const validation = validateText(localData.restrictionDetails, 3);
    
    if (!validation.valid) {
      setErrors({ restrictionDetails: validation.error || 'Campo obrigatório' });
      return;
    }
   
    updateFields(localData);
    onNext(localData);
  };

  return (
    <StepContainer
      title=""
      description=""
    >
      <div className="mb-6">
        <p className="font-semibold mb-2">Quais são as restrições?</p>
        <p className="text-muted-foreground text-sm mb-4">
          Descreva brevemente suas restrições para que a gente possa entender melhor sua situação.
        </p>
        <div className="bg-blue-50 border border-blue-200 rounded-md p-3 mb-4">
          <p className="text-blue-900 text-sm">
            💡 Exemplos: SPC, Serasa, Débito em aberto, Cheque devolvido, etc.
          </p>
        </div>
      </div>
      <FormFieldGroup
        label="Descreva suas restrições"
        error={errors.restrictionDetails}
        required
      >
        <input
          type="text"
          placeholder="Ex: Tenho um débito em aberto..."
          value={localData.restrictionDetails}
          onChange={(e) => handleChange(e.target.value)}
          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-[#5c5c5c]"
        />
      </FormFieldGroup>

      <StepNavigation
        onNext={handleNext}
        onPrevious={() => onNext(localData,'step9_restricoes')}
        isLoading={isLoading}
        showPrevious={true}
      />
    </StepContainer>
  );
};

export default Step2_Nome;
